var map = {
	"./en": [
		"/WL+",
		1
	],
	"./en.json": [
		"/WL+",
		1
	],
	"./km": [
		"bfaW",
		0
	],
	"./km.json": [
		"bfaW",
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "KYPc";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/lang lazy ^\.\/.*$
// module id = KYPc
// module chunks = 12